import {
  IDictionaryBasicEventFieldsFragment,
  IVirtualEventFieldsFragment,
} from '../../../apollo/graphqlSchema';
import { getEventEventProperties } from './utils';
import { IAnalyticsEventEvent } from './types';

export const virtualEventSaved = (
  virtualEvent: IVirtualEventFieldsFragment,
): IAnalyticsEventEvent => ({
  eventName: 'Virtual Event Saved',
  ...getEventEventProperties(virtualEvent),
});

export const eventInformationUpdated = (
  event: IDictionaryBasicEventFieldsFragment,
): IAnalyticsEventEvent => {
  return {
    eventName: 'Event Information Updated',
    ...getEventEventProperties(event),
  };
};

export const virtualEventInformationUpdated = (
  event: IVirtualEventFieldsFragment,
): IAnalyticsEventEvent => {
  return {
    eventName: 'Virtual Event Information Updated',
    ...getEventEventProperties(event),
  };
};
